/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type DeliveryOrderDetailInput = {
  readonly addressId: string | number;
  readonly deliveryFee: number;
  readonly tip: number;
  readonly vendor: string;
  readonly vendorRestaurantId: string;
};

export type NotificationType = 'LIVE_ACTIVITY' | 'PUSH' | 'SMS';

export type SubmitOrderUsingPaymentMethodInput = {
  /** Shortcut for updating the customer's contact number */
  readonly contactNumber?: string | null | undefined;
  readonly deliveryOrderDetail?: DeliveryOrderDetailInput | null | undefined;
  /** Selected from restaurant.availableDropoffLocations, if it exists */
  readonly dropoffLocationId?: string | number | null | undefined;
  readonly includeUtensils?: boolean | null | undefined;
  readonly notificationType?: NotificationType | null | undefined;
  readonly orderId: string | number;
  /** Customer's saved Payment Method */
  readonly paymentMethodId: string | number;
  readonly pickupTip?: number | null | undefined;
  readonly shouldTrackPurchase?: boolean | null | undefined;
  /** Whether or not to apply the customer's available credit towards the transaction */
  readonly useCredit: boolean;
  /** Whether or not to apply HSA/FSA (Flex) funds towards eligible items */
  readonly useHsa?: boolean | null | undefined;
  /** The time at which the customer expects to receive their order, selected from order.availableWantedTimes */
  readonly wantedTime: string;
};

export type ValidateRewardFailureCode =
  | 'CART_NOT_FOUND'
  | 'CHANNEL_RESTRICTION'
  | 'DAY_RESTRICTION'
  | 'LOYALTY_LOCATION_NOT_FOUND'
  | 'LOYALTY_NOT_PROCESSED'
  | 'LOYALTY_PROGRAM_UNAVAILABLE'
  | 'MISSING_SKU'
  | 'PRICE_MAXIMUM'
  | 'PRICE_MINIMUM'
  | 'RESTAURANT_NOT_ACCEPTING_ORDERS'
  | 'REWARD_EXPIRED'
  | 'REWARD_NOT_APPLICABLE'
  | 'REWARD_NOT_FOUND'
  | 'TIME_RESTRICTION';

export type SubmitBagOrderWithPaymentMethodMutationVariables = Exact<{
  input: Types.SubmitOrderUsingPaymentMethodInput;
}>;

export type SubmitBagOrderWithPaymentMethodMutation = {
  readonly submitOrderUsingPaymentMethod:
    | { readonly __typename: 'DeclinedPaymentMethod' }
    | { readonly __typename: 'DeliveryAlreadyInFlight' }
    | { readonly __typename: 'DeliverySpecifyAddress' }
    | { readonly __typename: 'IncorrectPaymentMethod' }
    | { readonly __typename: 'InvalidCustomerPhone' }
    | { readonly __typename: 'InvalidTip'; readonly message: string; readonly status: number }
    | { readonly __typename: 'MinimumDeliverySubtotalNotMet' }
    | { readonly __typename: 'ProductOutOfStock' }
    | {
        readonly __typename: 'ProductUnavailable';
        readonly message: string;
        readonly status: number;
      }
    | {
        readonly __typename: 'RestaurantIsNotAcceptingOrders';
        readonly message: string;
        readonly status: number;
      }
    | {
        readonly __typename: 'RewardNotValidated';
        readonly message: string;
        readonly status: number;
        readonly failureCode: Types.ValidateRewardFailureCode;
      }
    | { readonly __typename: 'StoreOffline' }
    | {
        readonly __typename: 'SubmitOrderUsingPaymentMethodSuccess';
        readonly order: {
          readonly __typename: 'Order';
          readonly id: string;
          readonly wantedTime: string;
          readonly hasEarnedLoyaltyPoints: boolean;
        };
      }
    | { readonly __typename: 'TimeslotUnavailable' }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{ readonly field: string; readonly message: string }>;
      };
};

export const SubmitBagOrderWithPaymentMethodDocument = gql`
  mutation SubmitBagOrderWithPaymentMethod($input: SubmitOrderUsingPaymentMethodInput!) {
    submitOrderUsingPaymentMethod(input: $input) {
      __typename
      ... on SubmitOrderUsingPaymentMethodSuccess {
        order {
          id
          __typename
          wantedTime
          hasEarnedLoyaltyPoints
        }
      }
      ... on RewardNotValidated {
        message
        status
        failureCode
      }
      ... on ProductUnavailable {
        message
        status
      }
      ... on RestaurantIsNotAcceptingOrders {
        message
        status
      }
      ... on InvalidTip {
        message
        status
      }
      ... on ValidationError {
        message
        status
        fieldErrors {
          field
          message
        }
      }
    }
  }
`;

export function useSubmitBagOrderWithPaymentMethodMutation() {
  return Urql.useMutation<
    SubmitBagOrderWithPaymentMethodMutation,
    SubmitBagOrderWithPaymentMethodMutationVariables
  >(SubmitBagOrderWithPaymentMethodDocument);
}
